/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleCheckFill: {
  name: 'circle-check-fill';
  data: string;
} = {
  name: 'circle-check-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm4.64 7.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 1 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z" fill="currentColor"/></svg>`,
};
